import PropTypes from 'prop-types'
import classNames from 'classnames'

import style from '@aytm/app/stats/page/question-views/vk/components/chart-note/styles/ChartNote.module.scss'

const ChartNote = ({ children, error }) => (
  <div className={classNames(style.chartNote, { [style.error]: error })}>{children}</div>
)

ChartNote.propTypes = {
  children: PropTypes.any,
  error: PropTypes.bool
}

export default ChartNote
